module.exports = __webpack_public_path__ + "img/t1-3.eb8ee972.png";